<template>
      <div class="flex flex-wrap items-center justify-center">
			<template v-if="!isFormVisible">
				{{fieldData}}
				<vs-button v-if="showEditBtn" class="ml-2" size="small" color="dark" icon-pack="feather" icon="icon-edit" @click="isFormVisible=true"></vs-button>
				<vs-button v-if="showDeleteBtn" class="ml-2" size="small" color="danger" icon-pack="feather" icon="icon-trash" @click="confirmDeleteData"></vs-button>
			</template>
			<template v-else>
			<vs-input
			size="small" 
				name="fieldValue"
				v-validate="requiredRules"
				v-model.lazy="fieldValue"
				:danger="hasError('fieldValue')"
				:danger-text="errorText('fieldValue')"
				:success="isSuccess('fieldValue')"
				icon-pack="feather"
				:placeholder="requiredPlaceholder"
				/>
			<vs-button size="small" class="ml-2" color="success" icon-pack="feather" icon="icon-check" @click="updateData"></vs-button>
			<vs-button size="small" class="ml-2" color="danger" icon-pack="feather" icon="icon-x" @click="isFormVisible=false"></vs-button>
			</template>
	</div>
  </template>
  
  <script lang="js">  
  export default  {
    name: 'update-attribute',
    props: {
		objectDb: {
        required: true
      },
        fieldOption: {
        required: true
      },
      fieldData: {
        required: true
      },
      editEnabled: {
        default: true
      },
      deleteEnabled: {
        default: false
      },
    },
    data() {
      return {
        requiredRules: "required",
        requiredPlaceholder: "(Requerido)",
        isFormVisible:false,
        fieldValue: this.fieldData
      }
    },
    computed: {
      showEditBtn(){
        let showBtn = true;
        if (!this.editEnabled) {
          showBtn=false;
        } else {
          showBtn = (this.rolesOfUser.includes("security") || this.rolesOfUser.includes("admin"));
        }
        return showBtn;
      },
      showDeleteBtn(){
        let showBtn = true;
        if (!this.deleteEnabled || !this.fieldData) {
          showBtn=false;
        } else {
          showBtn = (this.rolesOfUser.includes("pld") || this.rolesOfUser.includes("admin"));
        }
        return showBtn;
      },
    },
    methods: {
		async updateData() {
      this.errorMssg = null;
      if (!(await this.validateForm())) {
        return;
      }
      this.showLoading(true, "Guardando información...");
      try {
        let payload = {
          object_db: this.objectDb,
          field_option: this.fieldOption,
          prev_value: this.fieldData,
          field_value: this.fieldValue,
        };
        await axios.post("/api/clients-control/users-profile-integration/update",
          payload
        );
        this.showLoading(false);
        // this.fieldData = this.fieldValue;
        // this.isFormVisible = false;
        // this.successNotifDialog("Operación exitosa","Dato actualizado exitosamente");
        this.$emit("updated");
      } catch (error) {
        if(error.response){
          this.errorNotifDialog("Aviso", error.response.data.message);
        }
        else {
          this.errorNotifDialog("Error", "Ha ocurrido un error");
        }
        this.showLoading(false);
      }
    },
    confirmDeleteData(){
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: `Realizar Eliminación`,
        text: `¿Estás seguro que deseas eliminar el dato para el usuario?`,
        acceptText: "Aceptar",
        cancelText: 'Cancelar',
        accept: this.deleteData
      });
    },
		async deleteData() {
      this.errorMssg = null;
      this.showLoading(true, "Guardando información...");
      try {
        let payload = {
          object_db: this.objectDb,
          field_option: this.fieldOption,
          prev_value: this.fieldData
        };
        await axios.post("/api/clients-control/users-profile-integration/delete",
          payload
        );
        this.showLoading(false);
        // this.fieldData = this.fieldValue;
        // this.isFormVisible = false;
        // this.successNotifDialog("Operación exitosa","Dato actualizado exitosamente");
        this.$emit("updated");
      } catch (error) {
        if(error.response){
          this.errorNotifDialog("Aviso", error.response.data.message);
        }
        else {
          this.errorNotifDialog("Error", "Ha ocurrido un error");
        }
        this.showLoading(false);
      }
    },
    async validateForm() {
      this.errorMssg = null;
      return this.$validator.validateAll();
    },
      hasError(val) {
        return this.errors.has(val);
      },
      errorText(val) {
        return this.errors.first(val);
      },
      isSuccess(val) {
        let ff = this.fields[val];
        return ff && ff.required && ff.valid;
      },
    }
  }
  </script>